// eslint-disable-next-line no-unused-vars
import { request } from '@/utils/request/request';
// eslint-disable-next-line import/prefer-default-export
export function getInformation() {
  return request({
    url: 'api/tongji/v1/GetInformation',
    method: 'get',
  });
}
